import React from 'react';

function ImprintDE() {
  return (
    <div className="tm-imprint">
      <h1>Impressum.</h1>
      <p>
        <b>Gesamtverantwortung Trafimage.</b>
        <br />
        <br />
        SBB AG
        <br />
        Infrastruktur – Anlagen und Technologie – Operation Center Technik –
        Technical Management
        <br />
        Fachbus Trafimage
        <br />
        Poststrasse 6
        <br />
        CH-3072 Ostermundingen
        <br />
        <a href="http://www.trafimage.ch">www.trafimage.ch</a>
        <br />
      </p>
      <p>
        <b>
          Betrieb, Wartung und Weiterentwicklung der Trafimage-Anwendungen,
          Datenintegration.
        </b>
        <br />
        <br />
        geOps AG
        <br />
        Solothurnerstrasse 235
        <br />
        CH-4600 Olten
        <br />
        <a href="http://www.geops.ch">www.geops.ch</a>
        <br />
      </p>
      <p>
        <b>Karten und - Bahnhofplanerstellung.</b>
        <br />
        <br />
        evoq communications AG
        <br />
        Ottikerstrasse 59
        <br />
        CH-8006 Zürich
        <br />
        <a href="http://www.evoq.ch">www.evoq.ch</a>
        <br />
      </p>
    </div>
  );
}

export default ImprintDE();
